"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _style = require("./style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ManueverContainer = function ManueverContainer() {
  return /*#__PURE__*/_react["default"].createElement(_style.Manuever, null, /*#__PURE__*/_react["default"].createElement(_style.Icon, {
    style: {
      justifyContent: 'flex-end',
      marginTop: '.7rem'
    }
  }, "\u2321"), /*#__PURE__*/_react["default"].createElement(_style.Dotted, null, /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement(_style.Icon, {
    style: {
      justifyContent: 'flex-start',
      marginBottom: '.7rem'
    }
  }, "\u2320"));
};

var _default = ManueverContainer;
exports["default"] = _default;